/* Constants - similar to config.js */ 

module.exports = {
    "responsive" : {
        "mobile" : 1024,
        "tablet" : 1024
    }
}